import { render, staticRenderFns } from "./WelcomeSignOverrideForm.vue?vue&type=template&id=0c5241ee&scoped=true"
import script from "./WelcomeSignOverrideForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSignOverrideForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WelcomeSignOverrideForm.vue?vue&type=style&index=0&id=0c5241ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5241ee",
  null
  
)

export default component.exports